exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#btn-dropdown-themeSelection {\n  background-color: #1594A6;\n  display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/edit-annotation-dialog/edit-annotation-dialog.component.scss
// module id = ../../../../../src/app/components/edit-annotation-dialog/edit-annotation-dialog.component.scss
// module chunks = main